// extracted by mini-css-extract-plugin
export default {"svg":"styles_svg__pO1k8"};